import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import {ForgotPassword} from 'app/modules/auth/components/ForgotPassword'
import {ResetPassword} from 'app/modules/auth/components/ResetPassword'
import {AccountVerification} from 'app/modules/auth/components/AccountVerifcation'
import OnlineMembership from 'app/modules/online-membership/OnlineMembership'
import EventParticipation from 'app/modules/Event/EventParticipation'
import SurveyParticipation from 'app/modules/survey/SurveyParticipation'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
          <Route path='account-activation' element={<AccountVerification />} />
          <Route path='register' element={<OnlineMembership />} />
          <Route path='event/:id' element={<EventParticipation />} />
          <Route path='survey/:id' element={<SurveyParticipation />} />
          <Route path='reset-password/:token' element={<ResetPassword />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
